import { UserRoles } from "../lib/role-based-access-control";
import { AccountType, RegistryCode } from "./generated/graphql";

export type TraceXSupportedRegistries = Exclude<RegistryCode, RegistryCode.Icx>;

export const ANY_REGISTRY_CODE = null;
export const ANY_REGISTRY_ID = "any";

export type AggregatedRegistryCode = TraceXSupportedRegistries | typeof ANY_REGISTRY_CODE;

export type EnabledRegistries = Record<TraceXSupportedRegistries, { accountType: AccountType }>;

export type CustomUserClaims = {
  accountUid: string;
  roles: UserRoles[];
  forwardTradeEnabled: boolean;
  enabledRegistries: string;
};
